import { render, staticRenderFns } from "./WorkIconAttention.vue?vue&type=template&id=5aba32bb"
import script from "./WorkIconAttention.vue?vue&type=script&lang=js"
export * from "./WorkIconAttention.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports